var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5357_1116",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5357_1116)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99999 10.6667L4.66666 7.33334L5.59999 6.36667L7.33332 8.10001V2.66667H8.66666V8.10001L10.4 6.36667L11.3333 7.33334L7.99999 10.6667ZM3.99999 13.3333C3.63332 13.3333 3.31943 13.2028 3.05832 12.9417C2.79721 12.6806 2.66666 12.3667 2.66666 12V10H3.99999V12H12V10H13.3333V12C13.3333 12.3667 13.2028 12.6806 12.9417 12.9417C12.6805 13.2028 12.3667 13.3333 12 13.3333H3.99999Z",
    fill: "#BB448B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download_icon.f136a4b59ae0964e2c3a7b3d982b9048.svg";
export { ForwardRef as ReactComponent };